import React, {PropTypes} from "react";
import {Field, reduxForm} from "redux-form";
import {TextField} from "redux-form-material-ui";

const validate = values => {
  const errors = {};
  if (values.emailIdPersonal && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailIdPersonal)) {
    errors.emailIdPersonal = 'Invalid email address'
  }


  return errors


}

class ContactInfoEdit extends React.Component {

  constructor() {
    super();
  }

  render() {

    const {handleSubmit, reset} = this.props;
    return (
      <div className="col-md-12">
        <form onSubmit={handleSubmit(data=> {
          this.props.submitHandler(data);

        })}>
          <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
            <thead>
            <tr>
              <th cellPadding="0" colSpan="4">
                <span className="bold pull-left">Contact Info</span>
                <span className="bold hrms-link pull-right">
                     <button type="button" onClick={this.props.close}><i className="glyphicon glyphicon-remove"
                     ></i>Cancel</button> </span>
                <span className="bold hrms-link pull-right"><a type="submit">
                     <button type="submit"><i className="glyphicon glyphicon-saved"></i>Save</button></a></span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style={{align: 'left', width: '18%'}}>Contact No:</td>
              <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                    <Field
                      name="contactNo"
                      component={TextField}/></span>
              </td>
              <td style={{align: 'left', width: '18%'}}>Emergency No:</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                     <Field
                       name="emergencyNo"
                       component={TextField}/>
                  </span>
              </td>
            </tr>
            <tr>
              <td style={{align: 'left'}}>Skype Id :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                    <Field

                      name="skypeId"
                      autoOk={true}
                      component={TextField}/>
                  </span>
              </td>
              <td style={{align: 'left'}}>Email Id Personal:</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText"><Field
                    name="emailIdPersonal"
                    autoOk={true}
                    component={TextField}/></span>
              </td>
            </tr>


            <tr>
              <td style={{align: 'left'}}>Address :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText"><Field
                    name="address"
                    multiLine={true}
                    rows="3"
                    rowsMax="3"

                    component={TextField}/></span>
              </td>
            </tr>

            </tbody>
          </table>
        </form>


      </div>
    );
  }
}

ContactInfoEdit.propTypes = {};

export default reduxForm({
  form: 'contactInfo',
  validate


})(ContactInfoEdit)






/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/EmployeeSS/Tables/ContactInfoEdit.js
 **/